import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { CustomDirectivesModule } from "@app/_directives/custom-directives.module";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { ParseNamePipe } from "@app/_pipes/parse-name.pipe";
import { AppService } from "@app/app.service";
import { AuditFilterPopoverModule } from "@app/components/audit-filter-popover/audit-filter-popover.module";
import { ClientFilterPopoverModule } from "@app/components/client-filter-popover/client-filter-popover.module";
import { ComegoTypeFilterPopoverModule } from "@app/components/comego-type-filter-popover/comego-type-filter-popover.module";
import { ContingentExportDialogModule } from "@app/components/contingent-export-dialog/contingent-export-dialog.module";
import { DayPickerPopoverModule } from "@app/components/day-picker-popover/day-picker-popover.module";
import { EmployeeFilterPopoverModule } from "@app/components/employee-filter-popover/employee-filter-popover.module";
import { FilterTriggerButtonModule } from "@app/components/filter-trigger-button/filter-trigger-button.module";
import { GroupsFilterPopoverModule } from "@app/components/groups-filter-popover/groups-filter-popover.module";
import { ProjectFilterPopoverModule } from "@app/components/project-filter-popover/project-filter-popover.module";
import { TimeEntryModule } from "@app/components/reports/time-entry/time-entry.module";
import { ReportsExportDialogModule } from "@app/components/reports-export-dialog/reports-export-dialog.module";
import { ScheduleExportDialogModule } from "@app/components/schedule-export-dialog/schedule-export-dialog.module";
import { ShellMenuToggleModule } from "@app/components/shell-menu-toggle/shell-menu-toggle.module";
import { TagFilterPopoverModule } from "@app/components/tag-filter-popover/tag-filter-popover.module";
import { TaskFilterPopoverModule } from "@app/components/task-filter-popover/task-filter-popover.module";
import { TimeBulkEditDialogModule } from "@app/components/time-bulk-edit-dialog/time-bulk-edit-dialog.module";
import { TimeEditPopoverModule } from "@app/components/time-edit-popover/time-edit-popover.module";
import { MaterialModule } from "@app/material.module";
import { FabricBaseIconModule } from "@app/modules/fabric/fabric-base-icon/fabric-base-icon.module";
import { FabricFileIconModule } from "@app/modules/fabric/fabric-file-icon/fabric-file-icon.module";
import { TgToolbarModule } from "@app/shared/dialogs/tg-toolbar/tg-toolbar.module";
import { SaveDashboardDialogModule } from "@app/shared/save-dashboard-dialog/save-dashboard-dialog.module";
import { SharedModule } from "@app/shared/shared.module";
import { TimeDatePickerModule } from "@app/shared/time-date-picker/time-date-picker.module";
import { TimeRangePickerModule } from "@app/shared/time-range-picker/time-range-picker.module";
import { TimeTrackerCalendarUpdateDialogModule } from "@app/shared/time-tracker-calendar-update-dialog/time-tracker-calendar-update-dialog.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { UserMenuModule } from "@app/shared/user-menu/user-menu.module";
import { SatPopoverModule } from "@ncstate/sat-popover";
import { TranslateModule } from "@ngx-translate/core";
import {
	ApplicationSettingsQuery,
	ProjectsQuery,
	TagsQuery,
	TimesService,
	UserSettingsQuery,
} from "@timeghost/web-api";
import { NgApexchartsModule } from "ng-apexcharts";
import { DateFnsModule, FormatPipe } from "ngx-date-fns";
import { ContingentPageComponent } from "./contingent-page/contingent-page.component";
import { DataTableModule } from "./data-table/data-table.module";
import { DetailedPageComponent } from "./detailed-page/detailed-page.component";
import { ReportsComponent } from "./reports.component";
import { ReportsService } from "./reports.service";
import { ReportsDownloadDialogComponent } from "./reports-download-dialog/reports-download-dialog.component";
import { ReportsFilterBarComponent } from "./reports-filter-bar/reports-filter-bar.component";
import { ReportsGraphComponent } from "./reports-graph/reports-graph.component";
import { ReportsRoutingModule } from "./reports-routing.module";
import { ReportsToolbarActionsComponent } from "./reports-toolbar-actions/reports-toolbar-actions.component";
import { SchedulesPageComponent } from "./schedules-page/schedules-page.component";
import { SchedulesTableComponent } from "./schedules-page/schedules-table/schedules-table.component";
import { SummaryPageComponent } from "./summary-page/summary-page.component";
@NgModule({
	declarations: [
		ReportsComponent,
		ReportsDownloadDialogComponent,
		ReportsGraphComponent,
		DetailedPageComponent,
		SummaryPageComponent,
		SchedulesPageComponent,
		ContingentPageComponent,
		SchedulesTableComponent,
		ReportsFilterBarComponent,
		ReportsToolbarActionsComponent,
	],
	imports: [
		CommonModule,
		MaterialModule,
		NgApexchartsModule,
		CustomDirectivesModule,
		SharedModule,
		TgToolbarModule,
		FormsModule,
		ReactiveFormsModule,
		DataTableModule,
		TranslateModule,
		TimeRangePickerModule,
		UserMenuModule,
		FabricBaseIconModule,
		FabricFileIconModule,
		ReportsRoutingModule,
		ShellMenuToggleModule,
		EmployeeFilterPopoverModule,
		ProjectFilterPopoverModule,
		ClientFilterPopoverModule,
		FilterTriggerButtonModule,
		SatPopoverModule,
		TaskFilterPopoverModule,
		GroupsFilterPopoverModule,
		TimeEntryModule,
		TimeEditPopoverModule,
		AuditFilterPopoverModule,
		TagFilterPopoverModule,
		TimeBulkEditDialogModule,
		ScrollingModule,
		ReportsExportDialogModule,
		ScheduleExportDialogModule,
		ContingentExportDialogModule,
		DateFnsModule,
		UserAvatarModule,
		DayPickerPopoverModule,
		ParseNamePipe,
		SaveDashboardDialogModule,
		ComegoTypeFilterPopoverModule,
		TimeDatePickerModule,
		TimeTrackerCalendarUpdateDialogModule,
		CustomPipesModule,
	],
	exports: [ReportsRoutingModule],
	providers: [FormatPipe],
})
export class ReportsModule {
	static forRoot(): ModuleWithProviders<ReportsModule> {
		return {
			ngModule: ReportsModule,
			providers: [
				{
					provide: ReportsService,
					useClass: ReportsService,
					deps: [
						TimesService,
						ProjectsQuery,
						UserSettingsQuery,
						AppService,
						ApplicationSettingsQuery,
						Router,
						TagsQuery,
					],
				},
			],
		};
	}
}
